import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  buttonContainer: {justifyContent: 'flex-start', gap: 5},
  topButtonContainer: {
    justifyContent: 'flex-start',
    borderWidth: 1,
    paddingVertical: 2,
    borderRadius: 10,
    paddingHorizontal: 5,
  },
  bottomButtonContainer: {
    justifyContent: 'flex-start',
    borderWidth: 1,
    paddingLeft: 5,
    borderRadius: 10,
    paddingVertical: 1,
  },
  leftAlign: {textAlign: 'left'},
  rightMargin: {marginRight: 5},
});
